module.exports = __webpack_public_path__ + "img/code2.6d1e1316.png";